import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FormState {
  activeStep: number;
  policyName: string;
}

const initialState: FormState = {
  activeStep: 0,
  policyName: "",
};

const formSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    setActiveStep: (state, action: PayloadAction<number>) => {
      state.activeStep = action.payload;
    },
    setPolicyName: (state, action: PayloadAction<string>) => {
      state.policyName = action.payload;
    },
  },
});

export const { setActiveStep, setPolicyName } = formSlice.actions;

export default formSlice.reducer;




